import { X } from "lucide-react";
import { useProto } from "./ProtoContext";
import { Sheet } from "./Sheet";
import { listFor, COMFORTABLE_LOAD } from "./directory";
import { PEOPLE, leaderName } from "./data";
import { PersonLine, lastText } from "./ui";
import { AssignButton, RemindButton } from "./Actions";

export default function ListSheet() {
  const { list, closeList, isPhone, rhythm, assigned, openPerson } = useProto();
  const data = list.key ? listFor(list.key, rhythm, assigned) : null;
  const open = (id) => { closeList(); openPerson(id); };
  const overloaded = list.key?.startsWith("leader:") && data.items.length > COMFORTABLE_LOAD;
  const action = (p) => {
    if (!p.caregiver) return <AssignButton item={p} />;
    if (p.next) return <RemindButton id={p.id} leader={p.caregiver} />;
    return overloaded ? <AssignButton item={p} label="Move" exclude={p.caregiver} /> : null;
  };
  return (
    <Sheet open={list.open} onClose={closeList} isPhone={isPhone} testid="list-sheet">
      {data && (
        <div className="px-6 pt-4 pb-10">
          <div className="flex justify-end">
            <button onClick={closeList} aria-label="Close" className="h-11 w-11 rounded-full bg-sunk flex items-center justify-center text-ink-soft" data-testid="list-sheet-close"><X size={18} /></button>
          </div>
          <h2 className="t-title" data-testid="list-sheet-title">{data.title}</h2>
          <p className="text-ink-soft mt-2">{data.hint}</p>
          <div className="mt-4 divide-y divide-line" data-testid="list-sheet-rows">
            {data.items.map((p) => (
              <PersonLine
                key={p.id}
                p={p}
                testid={`list-row-${p.id}`}
                why={p.reason}
                last={lastText(p)}
                next={p.next}
                owner={p.caregiver ? leaderName(p.caregiver) : null}
                showOwner
                onOpen={PEOPLE[p.id] ? () => open(p.id) : null}
                right={action(p)}
              />
            ))}
          </div>
        </div>
      )}
    </Sheet>
  );
}
